module.exports = __webpack_public_path__ + "static/img/logo_black.27f9a902.svg";